import React from 'react';

import { Text } from '@change/ds-core-ui/Text';
import { Checkbox } from '@change/ds-forms';

import { usePublicInput } from './hooks/usePublicInput';
import { useTracking } from './hooks/useTracking';

export const PublicInput: React.FC<EmptyProps> = () => {
	const {
		data: { isPublic, label, displayed },
		actions: { setPublic },
	} = usePublicInput();
	const { trackPublicInputClick, trackPublicInputFocus } = useTracking();

	if (!displayed) return null;

	return (
		<Checkbox
			name="public_input"
			defaultSelected={isPublic}
			onFocus={trackPublicInputFocus}
			onChange={() => {
				setPublic(!isPublic);
				trackPublicInputClick();
			}}
			data-qa="input-public-promotion"
		>
			<Text variant="body" className="text-size-body-xs text-typography-strong md:text-size-body-small">
				{label}
			</Text>
		</Checkbox>
	);
};
